import { DataDirection } from '../../../core/types/ui/position';
import { FilterResults, Freeze, IRange } from '../../types';
import { isRangeWithinRange } from '../../utils/area/range';
import { getUnHiddenPosition } from '../../utils/views/virtualViewport';
import { HiddenItems } from './cellViewTypes';

export type GetHiddenRanges = (pos: number, i: number) => Partial<HiddenItems>;
export type GetHiddenRangesEmpty = (pos: number, i: number) => undefined;

export const getHiddenRanges =
  (
    indexes: number[],
    hiddenRanges: IRange[],
    maxIndex: number,
    freezed: Freeze,
    filterResults?: FilterResults
  ) =>
  (pos: number, itemIndex: number) => {
    let previousHiddenRange: IRange | undefined;
    let nextHiddenRange: IRange | undefined;
    let hiddenRange: IRange | undefined;

    if (pos === 0) {
      let prevIndex = getUnHiddenPosition(
        [], // entitySizes,  We don't need size
        hiddenRanges,
        itemIndex,
        maxIndex,
        DataDirection.Backward,
        freezed,
        filterResults,
        1
      );
      if (prevIndex === itemIndex) prevIndex = -1;
      if (prevIndex < itemIndex) {
        const parentRange = { start: prevIndex, end: itemIndex };
        const { withinRange } = isRangeWithinRange(parentRange, hiddenRanges);
        if (withinRange) previousHiddenRange = parentRange;
      }
    }

    //   For last element in viewport
    if (pos === indexes.length - 1) {
      let nextIndex = getUnHiddenPosition(
        [], // entitySizes,
        hiddenRanges,
        itemIndex,
        maxIndex,
        DataDirection.Forward,
        freezed,
        filterResults,
        1
      );
      if (nextIndex === itemIndex) nextIndex = maxIndex + 1;
      if (nextIndex > itemIndex) {
        const parentRange = { start: itemIndex, end: nextIndex };
        const { withinRange } = isRangeWithinRange(parentRange, hiddenRanges);
        if (withinRange) nextHiddenRange = parentRange;
      }
    } else {
      //   For elements between viewport
      const nextIndex = indexes[pos + 1];
      if (nextIndex !== undefined) {
        const parentRange = { start: itemIndex, end: nextIndex };
        const { withinRange } = isRangeWithinRange(parentRange, hiddenRanges);
        if (withinRange) hiddenRange = parentRange;
      }
    }

    return {
      previousHiddenRange,
      nextHiddenRange,
      hiddenRange,
    };
  };
